export default __webpack_public_path__ + "img/21.105faccb.jpg";